import ZusDeclarationPackageApi from '../../../../../api-v2/bookkeeping/zus-declarations-package.js';
import awaitWrap from '../../../../procedures/await-wrap.js';
import action from '../../../abstract/action.js';

export default action({
  label: 'Odśwież',
  icon: 'RefreshCcwIcon',
  main: ({ item }) => (item.task_index_package_in_zus && !item.index_package_in_zus) || (item.status && item.status === 'Przesyłka przyjęta do kontroli'),
  render: ({ item }) => (item.task_index_package_in_zus && !item.index_package_in_zus) || (item.status && item.status === 'Przesyłka przyjęta do kontroli'),
  handle: async ({ reloadList, $vs, item }) => {
    $vs.loading();
    await ZusDeclarationPackageApi.getStatus({ zuspackageId: item.id }).then(response => {
      $vs.loading.close();
      $vs.notify({
        title: 'Sukces',
        text: 'Zestaw został zaktualizowany',
        color: 'success',
        position: 'bottom-right',
      });
      awaitWrap(reloadList)();
    }).catch(error => {
      $vs.loading.close();
      $vs.notify({
        title: 'Błąd',
        text: 'Problem z pobraniem danych z ZUS. Spróbuj ponownie',
        color: 'warning',
        position: 'bottom-right',
      });
    });
    $vs.loading.close();
  },
});
